import React from 'react';

const NavButton = ({ icon, label, onClick, isActive, soporteBadge }) => {
    return (
        <button
            className={`nav-button ${isActive ? 'active' : ''}`}
            onClick={onClick}
            aria-current={isActive ? 'page' : undefined}
            style={{ position: 'relative' }}
        >
            {icon}
            <span>{label}</span>
            {soporteBadge && (
                <span style={{
                    position: 'absolute',
                    top: 6,
                    right: 10,
                    width: 10,
                    height: 10,
                    background: '#e74c3c',
                    borderRadius: '50%',
                    display: 'inline-block',
                }} />
            )}
        </button>
    );
};

export default NavButton;